<div role="dialog" aria-labelledby="webhookPayloadPerMessageId">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="webhookPayloadPerMessageId" class="modal-title">
          Webhook Message por MessageId
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="onClose()"
        ></button>
      </div>
      <div class="modal-body">
        @if (isLoading) {
          <div class="row">
            <div class="col-xs-12 d-flex justify-content-center py-5">
              <mat-spinner
                [diameter]="25"
                [color]="'primary'"
                mode="indeterminate"
              />
            </div>
          </div>
        } @else if (message) {
          <pre>{{ message | json }}</pre>
        } @else {
          <p>Webhook retornou NULL</p>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [mat-dialog-close]="true">
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>
